// Safari doesn't uppercase "ə" via CSS text-transform; swap it to "Ə" inside uppercase elements.
const fixNode = (n) => {
  if (n.nodeType !== 3 || !n.nodeValue.includes("ə") || !n.parentElement) return;
  const el = n.parentElement;
  if (el.closest(".eyebrow, .uppercase, .bomb-label") || getComputedStyle(el).textTransform === "uppercase") n.nodeValue = n.nodeValue.replace(/ə/g, "Ə");
};

const walk = (root) => {
  if (root.nodeType === 3) return fixNode(root);
  if (root.nodeType !== 1) return;
  const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = it.nextNode(); n; n = it.nextNode()) fixNode(n);
};

export function startAzUppercaseFix() {
  walk(document.body);
  window.addEventListener("load", () => walk(document.body));
  new MutationObserver((list) => {
    for (const m of list) {
      if (m.type === "characterData") fixNode(m.target);
      else m.addedNodes.forEach(walk);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
}
